// import config from 'config';

/* eslint-disable */
import { authHeader } from '../_helpers';
import { api } from '../_helpers/api';
import * as Cookies from 'js-cookie';

// export const userService = {
//     login,
//     logout,
//     getAll
// };

export async function getDataNations() {
    return api.fetchData('/data/nations').then(res => {
        return res.data;
    });
}

export async function getDataProvinces() {
    return api.fetchData('/data/provinces').then(res => {
        return res.data;
    });
}

export async function getDataRegencies(id) {
    return api.fetchData('/data/regencies',{
        province_id : id
    }).then(res => {
        return res.data;
    });
}

export async function getDataDemografis() {
    return api.fetchData('/data/demografis').then(res => {
        return res.data;
    });
}

export async function getDataDepartemen() {
    return api.fetchData('/data/departemen').then(res => {
        return res.data;
    });
}

export async function getDataCheckComplete() {
    return api.fetchData('/data/check-data-complete').then(res => {
        return res.data;
    });
}



function login(username, password) {
    return api.postData('/auth/login',{
        'username' : username,
        'password' : password
    },true)
        // .then(handleResponse)
        .then(response => {
            console.log(response);
            // login successful if there's a jwt token in the response
            if (response.access_token) {
                Cookies.set('x-access-token', response.access_token);
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('user', JSON.stringify(response.user));
            }

            return response.user;
        });
}

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('user');
}

function getAll() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(`http://localhost:8080/users`, requestOptions).then(handleResponse);
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                location.reload(true);
            }
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}